import { BRAND_IMAGES, getBrandImageUrl } from '@/app/common/contentHubAssets.ts';
import type { Localization } from '../../../common/Localization';

export const getDeferredPaymentsImagePath = ({
  localization,
  isMessage = false,
}: {
  localization: Localization;
  isMessage?: boolean;
}) => {
  const imageName = isMessage ? BRAND_IMAGES.DEFERRED_PAYMENTS_MESSAGE : BRAND_IMAGES.DEFERRED_PAYMENTS;
  return getBrandImageUrl(imageName, localization);
};
